<template>
    <div>
        <div class="row mx-0 line bg-white p-2" :style="rowDetail ? 'border-bottom: none' : ''">
            <div class="col-2 px-1" style="">
                <span class="small">{{ moment(target.updated).format("MM/DD/YYYY") }}</span>
            </div>
            <div class="col-2 px-1">
                <span class="small">{{ target.name }}&nbsp;</span>
                <i
                    class="cursor-pointer fa fa-caret-right text-primary p-2"
                    :class="{ 'rot-90': rowDetail }"
                    @click="openDetail()"
                ></i>
            </div>
            <div class="col-1 px-1">
                <span class="small">{{ targetProbeCount }}</span>
            </div>
            <div class="col-2 px-1">
                <span class="small">{{
                    target.introduced ? moment(target.introduced).format("MM/DD/YYYY") : ""
                }}</span>
            </div>
            <div class="col-2 px-1">
                <div
                    class="d-flex justify-content-between align-items-center pr-2 h-100"
                    v-html="targetProgress()"
                ></div>
            </div>
            <div class="col-2 px-1">
                <span class="small">{{
                    target.retained ? moment(target.retained).format("MM/DD/YYYY") : ""
                }}</span>
            </div>
        </div>
        <div class="line p-3 bg-white" v-show="rowDetail">
            <div class="row ">
                <div class="col-2">
                    <span class="small">Date</span>
                </div>
                <div class="col-2">
                    <span class="small">Stage</span>
                </div>
                <div class="col-2">
                    <span class="small">Result</span>
                </div>
                <div class="col-2">
                    <span class="small">Notes</span>
                </div>
                <div class="col-2"></div>
            </div>

            <div
                class="row tracker-row"
                :class="trackerEditId && trackerEditId !== tracker.id ? 'text-muted' : ''"
                v-for="tracker in groupedTrackers"
            >
                <template v-if="hasConsistentData(tracker)">
                    <div class="col-2">
                        <span class="small">{{
                            tracker.session_at
                                ? moment(tracker.session_at).format("MM/DD/YYYY")
                                : ""
                        }}</span>
                    </div>
                    <div class="col-2">
                        <span class="small text-capitalize">{{
                            helpers._get(tracker, "data.targets[0].stage", "")
                        }}</span>
                    </div>
                    <div class="col-2">
                        <template
                            v-if="
                                Array.isArray(helpers._get(tracker, 'data.targets[0].result', []))
                            "
                        >
                            <template
                                v-if="helpers._get(tracker, 'data.targets[0].result', []).length"
                            >
                                <template
                                    v-for="result in helpers._get(
                                        tracker,
                                        'data.targets[0].result',
                                        []
                                    )"
                                >
                                    <i
                                        v-if="[0, 1, false, true].includes(result)"
                                        class="mr-1 fa"
                                        :class="
                                            [1, true].includes(result)
                                                ? 'fa-check text-success'
                                                : 'fa-times text-danger'
                                        "
                                    ></i>
                                    <span class="small" v-else="">Not Tracked</span>
                                </template>
                            </template>
                        </template>
                        <template v-else="">
                            <template
                                v-if="
                                    ![0, 1, false, true].includes(
                                        helpers._get(tracker, 'data.targets[0].result', null)
                                    )
                                "
                            >
                                <i
                                    class="mr-1 fa"
                                    :class="
                                        helpers._get(tracker, 'data.targets[0].result', null)
                                            ? 'fa-check text-success'
                                            : 'fa-times text-danger'
                                    "
                                ></i>
                            </template>

                            <span class="small" v-else="">Not tracked</span>
                        </template>
                    </div>
                    <div class="col-2">
                        <span class="small">{{ tracker.notes }}</span>
                    </div>
                    <div class="col-2">
                        <button
                            class="btn btn-link text-primary btn-sm small font-weight-bold"
                            @click="setEditTracker(tracker.id)"
                        >
                            <i class="fa fa-edit mr-1"></i>EDIT
                        </button>
                    </div>
                </template>
            </div>

            <div class="row" v-if="target.stage !== 'mastered'">
                <div class="col-2">
                    <v-date-picker
                        id="date"
                        class="picker-container"
                        popover-align="left"
                        v-model="date"
                    ></v-date-picker>
                </div>
                <div class="col-2">
                    <small class="text-capitalize">{{ target.stage }}</small>
                </div>
                <div class="col-2">
                    <button
                        class="btn btn-sm probe-choice"
                        @click="newProbe(1)"
                        :class="
                            newProbeResult && newProbeResult.length && newProbeResult[0] === 1
                                ? 'btn-success'
                                : 'btn-outline-success'
                        "
                    >
                        <i class="fa fa-check"></i>
                    </button>
                    <button
                        class="btn btn-sm probe-choice"
                        @click="newProbe(0)"
                        :class="
                            newProbeResult && newProbeResult.length && newProbeResult[0] === 0
                                ? 'btn-danger'
                                : 'btn-outline-danger'
                        "
                    >
                        <i class="fa fa-times"></i>
                    </button>
                </div>
                <div class="col-2">
                    <input v-model="notes" class="form-control form-control-sm" name="note" />
                </div>
                <div v-if="target.stage === 'baseline'" class="col-1">
                    <span v-for="b in newBaseline"
                        ><i
                            class="fa mr-1"
                            :class="b ? 'text-success fa-plus' : 'text-danger fa-times'"
                        ></i
                    ></span>
                </div>
                <div class="col-2">
                    <button
                        id="save-probe-data"
                        class="btn btn-sm btn-link text-primary small font-weight-bold text-uppercase mr-1"
                        @click="saveProbe()"
                    >
                        <i class="fa fa-times-circle-o rot-45 mr-1"></i>Add Data
                    </button>
                </div>
            </div>
        </div>

        <modal
            :id="`edit-tracker-${random}`"
            :visible="trackerEditId"
            :title="editModalTitle"
            @close="closeModal()"
        >
            <div class="p-3">
                <div class="row mb-3">
                    <div class="col-6">
                        <h5 class="font-weight-bold">Target:</h5>
                    </div>
                    <div class="col-6">
                        <h5 class="text-uppercase">{{ target.name }}</h5>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-6">
                        <span class="font-weight-bold">Current target stage:</span>
                    </div>
                    <div class="col-6">
                        <span class="text-capitalize">{{ target.stage }}</span>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-6">
                        <span class="font-weight-bold"
                            >Stage on
                            {{
                                trackerEditData.session_at
                                    ? moment(trackerEditData.session_at).format("MM/DD/YYYY")
                                    : "this session"
                            }}:</span
                        >
                    </div>
                    <div class="col-6">
                        <span class="text-capitalize">{{
                            trackerEditDataTarget ? trackerEditDataTarget.stage : ""
                        }}</span>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-6">
                        <span class="font-weight-bold">Data entered:</span>
                    </div>
                    <div class="col-6">
                        <template
                            v-if="
                                trackerEditDataTarget &&
                                    trackerEditDataTarget.hasOwnProperty('result')
                            "
                        >
                            <template v-if="Array.isArray(trackerEditDataTarget.result)">
                                <template v-if="trackerEditDataTarget.result.length">
                                    <div v-for="(result, index) in trackerEditDataTarget.result">
                                        <button
                                            class="btn btn-sm probe-choice"
                                            @click="editProbe(index, 1)"
                                            :class="
                                                [1, true].includes(result)
                                                    ? 'btn-success'
                                                    : 'btn-outline-success'
                                            "
                                        >
                                            <i class="fa fa-check"></i>
                                        </button>
                                        <button
                                            class="btn btn-sm probe-choice"
                                            @click="editProbe(index, 0)"
                                            :class="
                                                [0, false].includes(result)
                                                    ? 'btn-danger'
                                                    : 'btn-outline-danger'
                                            "
                                        >
                                            <i class="fa fa-times"></i>
                                        </button>
                                        <button
                                            class="btn btn-sm probe-choice"
                                            @click="editProbe(index, null)"
                                            v-tooltip="'Not tracked in this session'"
                                            :class="
                                                ![1, true, 0, false].includes(result)
                                                    ? 'btn-dark'
                                                    : 'btn-outline-dark'
                                            "
                                        >
                                            N/A
                                        </button>
                                    </div>
                                </template>
                                <template v-else="">
                                    <button
                                        class="btn btn-sm probe-choice btn-outline-success"
                                        @click="editProbe(0, 1)"
                                    >
                                        <i class="fa fa-check"></i>
                                    </button>
                                    <button
                                        class="btn btn-sm probe-choice btn-outline-danger"
                                        @click="editProbe(0, 0)"
                                    >
                                        <i class="fa fa-times"></i>
                                    </button>
                                </template>
                            </template>
                            <template v-else="">
                                <button
                                    class="btn btn-sm probe-choice"
                                    @click="editProbe(0, 1)"
                                    :class="
                                        [1, true].includes(trackerEditDataTarget.result)
                                            ? 'btn-success'
                                            : 'btn-outline-success'
                                    "
                                >
                                    <i class="fa fa-check"></i>
                                </button>
                                <button
                                    class="btn btn-sm probe-choice"
                                    @click="editProbe(0, 0)"
                                    :class="
                                        [0, false].includes(trackerEditDataTarget.result)
                                            ? 'btn-danger'
                                            : 'btn-outline-danger'
                                    "
                                >
                                    <i class="fa fa-times"></i>
                                </button>
                            </template>
                        </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-6">
                        <span class="font-weight-bold">Target stage after changes:</span>
                    </div>
                    <div class="col-6">
                        <span class="text-capitalize">{{ trackerEditUpdatedStage }}</span>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-12 d-flex justify-content-between align-items-center">
                        <button
                            id="cancel-edit"
                            class="btn btn-sm btn-link px-0 small"
                            @click="closeModal()"
                        >
                            Discard changes and go back
                        </button>
                        <button
                            id="confirm-edit"
                            class="btn btn-sm btn-primary text-uppercase"
                            @click="saveTracker()"
                        >
                            Confirm changes and update goal
                        </button>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { fixDatePickers } from "../../plugins/fixDatePickers";
import { helpers } from "../../plugins/helpers";
import Modal from "../ui/ModalComponent";

export default {
    name: "GoalsDataProbe",
    props: ["goal", "target", "trackers", "groupedTrackers"],
    mixins: [fixDatePickers],
    components: { Modal },
    data() {
        return {
            helpers,
            enteringData: false,
            rowDetail: false,
            date: new Date(),
            newProbeResult: [],
            newBaseline: [],
            notes: "",
            random: parseInt(Math.random() * 1e6),
            trackerEditId: null,
            trackerEditData: {},
            trackerEditDataTarget: {},
            trackerEditUpdatedStage: "",
            trackerEditGoalTeachingResults: [],
        };
    },
    computed: {
        targetProbeCount() {
            if (this.groupedTrackers && Array.isArray(this.groupedTrackers)) {
                return this.groupedTrackers.reduce((acc, cur) => {
                    // Manually tracked data was being saved as a boolean
                    // instead of an array with a binary result (as the tracker does),
                    // so we need to check how each tracker was saved
                    return (
                        acc +
                        (Array.isArray(_.get(cur, "data.targets[0].result", []))
                            ? _.get(cur, "data.targets[0].result", []).filter(result =>
                                  [0, false, 1, true].includes(result)
                              ).length //filters only tracked results
                            : _.get(cur, "data.targets[0].result", false) | 0)
                    );
                }, 0);
            }
            return 0;
        },

        editModalTitle() {
            if (this.trackerEditId && this.trackerEditData && this.trackerEditData.session_at) {
                if (this.moment(this.trackerEditData.session_at)._isValid) {
                    return `Editing session data for ${this.moment(
                        this.trackerEditData.session_at
                    ).format("MM/DD/YYYY")}`;
                }
                return "Editing session data";
            }
        },
    },

    methods: {
        targetProgress() {
            if (this.target.mastered) {
                return `<small>Acquired on ${this.moment(this.target.retained).format(
                    "MM/DD/YYYY"
                )}</small>`;
            }
            if (this.target.acquired) {
                return `<small>Acquired on ${this.moment(this.target.acquired).format(
                    "MM/DD/YYYY"
                )}</small>`;
            }
            return `
                    <div style="width: 100%;">
                        <div class="progress" style="height: 0.5rem;">
                            <div role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" class="progress-bar"
                            style="background-color:${
                                this.goal ? this.goal.domain.color : "#8f8f8f"
                            }; width:${this.goal.target_progresses[this.target.name]}%"></div>
                        </div>

                    </div>
                    <small class="ml-2">${this.goal.target_progresses[this.target.name] ||
                        0}%</small>
                    `;
        },

        openDetail() {
            this.rowDetail = !this.rowDetail;
        },

        hasConsistentData(tracker) {
            const result = _.get(tracker, "data.targets[0].result", []);
            if (Array.isArray(result)) {
                return result.length;
            }
            return true;
        },

        newProbe(result) {
            if (this.target.stage === "baseline") {
                if (
                    this.newBaseline.length <
                    this.goal.parameters.baseline_num_times_repeat_question
                ) {
                    this.newBaseline.push(result);
                } else {
                    this.newBaseline.splice(0, 1);
                    this.newBaseline.push(result);
                }
            } else {
                this.newProbeResult = [result];
            }
        },

        getUpdatedGoalTarget() {
            let target = { ...this.target };
            target.updated = this.moment().format("YYYY-MM-DD");
            switch (target.stage) {
                case "baseline":
                    if (target.baseline.length === 0) {
                        target.introduced = this.moment(this.date).format("YYYY-MM-DD");
                    }
                    target.baseline = this.newBaseline;
                    if (
                        target.baseline.length ===
                        this.goal.parameters.baseline_num_times_repeat_question
                    ) {
                        if (
                            target.baseline.filter(b => b).length >=
                            this.goal.parameters.baseline_considered_mastered
                        ) {
                            target.stage = "mastered";
                            target.retained = this.moment().format("YYYY-MM-DD");
                            target.mastered = true;
                        } else {
                            target.stage = "teaching";
                            if (this.goal.parameters.teaching_is_consecutive_days_required) {
                                target.next_probe = this.moment()
                                    .add(1, "d")
                                    .format("YYYY-MM-DD");
                            }
                        }
                    }
                    break;
                case "teaching":
                    target.teaching.push(this.newProbeResult[0]);
                    let failCount = 0;
                    if (
                        target.teaching.length >=
                        this.goal.parameters.teaching_num_times_repeat_question
                    ) {
                        for (
                            let i = 1;
                            i <= this.goal.parameters.teaching_num_times_repeat_question;
                            i++
                        ) {
                            if (!target.teaching[target.teaching.length - i]) {
                                failCount++;
                            }
                        }
                    }
                    if (
                        !failCount &&
                        target.teaching.length >=
                            this.goal.parameters.teaching_num_times_repeat_question
                    ) {
                        target.acquired = this.moment().format("YYYY-MM-DD");
                        target.stage = "acquired";
                        target.next_probe = this.moment()
                            .add(this.goal.parameters.retention_num_days_reprobe, "d")
                            .format("YYYY-MM-DD");
                    } else {
                        if (this.goal.parameters.teaching_is_consecutive_days_required) {
                            target.next_probe = this.moment()
                                .add(1, "d")
                                .format("YYYY-MM-DD");
                        }
                    }
                    break;
                case "acquired":
                    if (this.newProbeResult && this.newProbeResult && this.newProbeResult[0]) {
                        target.stage = "mastered";
                        target.mastered = "true";
                        target.retained = this.moment().format("YYYY-MM-DD");
                    } else {
                        target.stage = "teaching";
                        target.teaching = [];
                        if (this.goal.parameters.teaching_is_consecutive_days_required) {
                            target.next_probe = this.moment()
                                .add(1, "d")
                                .format("YYYY-MM-DD");
                        }
                    }
                    break;
            }
            return target;
        },

        saveProbe() {
            helpers.toggleSpinner("save-probe-data", "Saving...");
            let sessionTarget = {
                name: this.target.name,
                stage: this.target.stage,
                result: this.target.stage === "baseline" ? this.newBaseline : this.newProbeResult,
            };

            let trackerData = {
                goal_id: this.goal.id,
                session_at: this.moment(this.date).format("YYYY-MM-DD"),
                notes: this.notes,
                data: {
                    targets: [sessionTarget],
                },
                //total_mastered: ?
            };

            let goalParameters = this.goal.parameters;
            let goalTargets = goalParameters.targets;
            let targetToUpdate = goalTargets.find(t => t.name === this.target.name);
            let i = goalTargets.indexOf(targetToUpdate);
            goalTargets[i] = this.getUpdatedGoalTarget();
            goalParameters.targets = goalTargets;

            axios
                .post(
                    `/api/patients/${this.goal.patient.id}/goals/${this.goal.id}/trackers`,
                    trackerData
                )
                .then(r => {
                    axios
                        .patch(`/api/patients/${this.goal.patient.id}/goals/${this.goal.id}`, {
                            parameters: goalParameters,
                        })
                        .then(response => {
                            helpers.toggleSpinner("save-probe-data", "Saving...");
                            this.notes = "";
                            this.newProbeResult = [];
                            this.$emit("refresh-trackers");
                            this.$emit("goal-updated");
                        });
                })
                .catch(e => {
                    helpers.toggleSpinner("save-probe-data", "Saving...");
                    console.error(e);
                });
        },

        setEditTracker(id) {
            this.trackerEditId = id;
            if (!id) return;
            this.trackerEditData = JSON.parse(
                JSON.stringify(this.trackers.find(tracker => tracker.id === id))
            ); // Spread and Object.assign won't do here
            if (
                this.trackerEditData &&
                this.trackerEditData.data &&
                this.trackerEditData.data.targets &&
                this.trackerEditData.data.targets.length
            ) {
                this.trackerEditDataTarget = Object.assign(
                    {},
                    this.trackerEditData.data.targets.find(
                        trackerTarget => trackerTarget.name === this.target.name
                    )
                );
            }
            if (this.trackerEditDataTarget.stage === "teaching") {
                let goalTarget = _.get(this.goal, "parameters.targets", []).find(
                    target => target.name === this.target.name
                );
                this.trackerEditGoalTeachingResults = JSON.parse(
                    JSON.stringify(_.get(goalTarget, "teaching", []))
                );
            }
            this.trackerEditUpdatedStage = this.calculateUpdatedTargetStage();
        },

        closeModal() {
            this.trackerEditId = null;
            this.trackerEditData = {};
            this.trackerEditDataTarget = {};
            this.trackerEditGoalTeachingResults = [];
        },

        editProbe(index, result) {
            if (Array.isArray(this.trackerEditDataTarget.result)) {
                this.$set(this.trackerEditDataTarget.result, index, result);
            } else {
                this.$set(this.trackerEditDataTarget, "result", [result]);
            }
            this.trackerEditUpdatedStage = this.calculateUpdatedTargetStage();
        },

        calculateUpdatedTargetStage() {
            if (this.trackerEditDataTarget && this.trackerEditDataTarget.stage) {
                switch (this.trackerEditDataTarget.stage) {
                    case "baseline":
                        let successes = this.trackerEditDataTarget.result.filter(result => result);
                        if (
                            successes &&
                            successes.length >= this.goal.parameters.baseline_considered_mastered
                        ) {
                            return "mastered";
                        }
                        return "teaching"; // If criteria isn't met, procceed to teaching stage.

                    case "teaching":
                        const groupedTrackersTeaching = [
                            ...this.groupedTrackers.filter(tracker => {
                                const trackerTarget = _.get(tracker, "data.targets[0]", {});
                                return (
                                    trackerTarget.stage === "teaching" &&
                                    ([0, 1, false, true].includes(trackerTarget.result) ||
                                        (Array.isArray(trackerTarget.result) &&
                                            trackerTarget.result.length))
                                );
                            }),
                        ];

                        if (
                            this.trackerEditGoalTeachingResults.length ===
                            groupedTrackersTeaching.length
                        ) {
                            // Sanity check
                            const teachingTrackerIds = groupedTrackersTeaching.map(
                                tracker => tracker.id
                            );
                            const activeTrackerIndex = teachingTrackerIds.indexOf(
                                this.trackerEditId
                            );

                            if (activeTrackerIndex >= 0) {
                                let fixedResult = this.fixData(this.trackerEditDataTarget.result);

                                this.$set(
                                    this.trackerEditGoalTeachingResults,
                                    activeTrackerIndex,
                                    fixedResult[0]
                                );
                                let requiredTeachingSuccessNumber = this.goal.parameters
                                    .teaching_num_times_repeat_question;

                                if (
                                    this.trackerEditGoalTeachingResults.length >=
                                    requiredTeachingSuccessNumber
                                ) {
                                    // Tracked enough times to be able to advance
                                    let noFailsYet = true;
                                    for (let i = 0; i < requiredTeachingSuccessNumber; i++) {
                                        let result = this.trackerEditGoalTeachingResults[
                                            this.trackerEditGoalTeachingResults.length - 1 - i
                                        ]; /////
                                        if (!result) {
                                            noFailsYet = false;
                                        }
                                    }
                                    return noFailsYet
                                        ? "acquired"
                                        : this.trackerEditDataTarget.stage;
                                }
                            } else {
                                // Filling an empty session
                                console.warning("Data was not tracked in this session.");
                            }
                        } else {
                            console.warn("Data is not consistent.");
                        }
                        return this.trackerEditDataTarget.stage;

                    case "acquired":
                        let result = this.fixData(this.trackerEditDataTarget.result);
                        if (result[0]) {
                            return "mastered";
                        }
                        return "teaching";
                }
            }
        },

        fixData(result) {
            if ([0, false].includes(result)) {
                return [0];
            }
            if ([1, true].includes(result)) {
                return [1];
            }
            if (Array.isArray(result)) {
                return result;
            }
            return [];
        },

        saveTracker() {
            helpers.toggleSpinner("confirm-edit", "Saving...");

            let updatedGoalData = { ...this.goal };
            let goalTargetIndex = null;
            updatedGoalData.parameters.targets.forEach((target, index) => {
                if (target.name === this.target.name) {
                    goalTargetIndex = index;
                }
            });

            let target = { ...this.target };
            target.updated = this.moment().format("YYYY-MM-DD");
            target.stage = this.trackerEditUpdatedStage;
            if (this.trackerEditGoalTeachingResults.length) {
                target.teaching = this.trackerEditGoalTeachingResults;
            }
            if (this.trackerEditUpdatedStage === "mastered") {
                target.mastered = true;
                target.retained = this.trackerEditData.session_at;
            }
            if (this.trackerEditDataTarget.stage === "baseline") {
                target.baseline = this.trackerEditDataTarget.result;
            }
            updatedGoalData.parameters.targets[goalTargetIndex] = target;

            let updatedTracker = { ...this.trackerEditData };
            let trackerTargetIndex = null;
            updatedTracker.data.targets.forEach((target, index) => {
                if (target.name === this.target.name) {
                    trackerTargetIndex = index;
                }
            });
            updatedTracker.data.targets[trackerTargetIndex] = { ...this.trackerEditDataTarget };
            updatedTracker.data.targets[trackerTargetIndex].stage = this.trackerEditUpdatedStage;
            updatedTracker.is_manual_entry = true;

            axios
                .patch(
                    `/api/patients/${this.goal.patient.id}/goals/${this.goal.id}/trackers/${
                        this.trackerEditId
                    }`,
                    updatedTracker
                )
                .then(r => {
                    axios
                        .patch(`/api/patients/${this.goal.patient.id}/goals/${this.goal.id}`, {
                            parameters: updatedGoalData.parameters,
                        })
                        .then(response => {
                            helpers.toggleSpinner("confirm-edit", "Saving...");
                            this.closeModal();
                            this.notes = "";
                            this.newProbeResult = [];
                            this.$emit("refresh-trackers");
                            this.$emit("goal-updated");
                        });
                })
                .catch(e => {
                    helpers.toggleSpinner("confirm-edit", "Saving...");
                    if (_.get(e, "response.status", null) === 403) {
                        this.$swal({
                            title: "Error",
                            text: `This goal was created by ${_.get(
                                this.goal,
                                "created_by_user.name",
                                "another user"
                            )}, you are not authorized to edit it. `,
                            type: "error",
                            confirmButtonText: "Close",
                            confirmButtonColor: "#d64571",
                        });
                    } else {
                        this.$swal({
                            title: "Error",
                            text: "An error occurred trying to edit this goal.",
                            type: "error",
                            confirmButtonText: "Close",
                            confirmButtonColor: "#d64571",
                        });
                    }
                    console.error(e);
                });
        },
    },
};
</script>

<style scoped lang="scss">
.probe-choice {
    font-size: 0.5rem;
    line-height: 0.6rem;
    padding: 0.2rem 0.3rem;
}
.line:first-child {
    border: solid 1px #8f8f8f;
}
.line {
    border: solid 1px #8f8f8f;
    border-top: none;
}
div.flagged {
    background-color: #fcf8ed;
}
small.flagged {
    color: #ff0000;
    font-weight: 600;
}
.tracker-row:hover {
    background: #ffe6ec;
}
</style>
